<div class="orders_viewdiff d-none" id="backbtn" (click)="backbtn()"><div class="global_blackarrow mobileorder"></div>{{"myorder.selectDiffOrder" | cxTranslate}} </div>


<div class="col-lg-5 col-sm-12 col-12 open-order float_left" id="leftsection">

  
    <div class="form-group">
        <div class="col-md-8 col-lg-8 col-sm-8 col-8 no-padding for_tab_view float_left">
            <div class="input-group seach_order">
                <div class="input-group-addon">
                    <i class="fa fa-search"></i>
                </div>
                <input (keyup)="inputsearch($event);applyFilter()" class="form-control" id="open_order_search" name="lookup" type="text" placeholder="Search, filter, or sort your orders" [(ngModel)]="valformsummary">
            </div>
        </div>
                     <div class="col-md-1 col-2 filterbox float_left"  (click)="filteropen()">
            <span class="select_counter">{{count}}</span>
        </div>
        <div class="col-md-1 col-2 sortbox float_left" (click)="sortopen()" [ngClass]="togglesortView?'open':''"></div>
    
         
        <div class="filteropen" [ngClass]="togglefilterView?'open':''">
            <div class="prodsection">
                <div class="filterheader">{{"myorder.byproductlabel" | cxTranslate}}</div>

                <label *ngFor="let item of getfilterdata?.seqirusProductList; let i=index"> <input type="checkbox" class="registration_checkbox" name="prodname"  value={{item}}  [checked]="filterValues.filterbyproduct.includes(item)" (click)="incrementcountproduct($event,i);applyFilter()"> <span class="checkbox-button__control"></span>{{item}}</label>
                     
                    </div>
            <div class="statussection margin-T20">
                <div class="filterheader">{{"myorder.bystatuslabel" | cxTranslate}}</div>
                <div >
                    <div  *ngFor="let list of getstatus?.seqirusOrderStatusList;let i=index">

                        <label> 
                            
                            <input *ngIf="list=='Order Canceled'" type="checkbox" class="registration_checkbox" name="status" value='Canceled' [checked]="filterValues.filterbystatus.includes('Canceled')" (click)="incrementcountstatus($event,i);applyFilter()" >
                            <input *ngIf="list!='Order Canceled'" type="checkbox" class="registration_checkbox" name="status" value={{list}} [checked]="filterValues.filterbystatus.includes(list)" (click)="incrementcountstatus($event,i);applyFilter()" >

                             <span class="checkbox-button__control" ></span>
                            {{(list == 'Canceled')?'Order Canceled':list}}
                            </label>
                    </div>
                    
                </div>
                
              
            </div>
        </div>
        <div class="sortopen" [ngClass]="togglesortView?'open':''">
            <div class="row">
                <div class="col-md-6">
                    <div class="filterheader">{{"myorder.ordernumlabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="1to9" (click)="sortTest('1to9')"> <span class="radio-button__control"></span>{{"myorder.1to9label" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="9to1" (click)="sortTest('9to1')"> <span class="radio-button__control"></span>{{"myorder.9to1label" | cxTranslate}}</label>
                </div>
                <div class="col-md-6">
                    <div class="filterheader">{{"myorder.loclabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="AtoZ" (click)="sortTest('AtoZ')"> <span class="radio-button__control"></span>{{"myorder.atozlabel" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="ZtoA" (click)="sortTest('ZtoA')"> <span class="radio-button__control"></span>{{"myorder.ztoalabel" | cxTranslate}}</label>
    
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-12">
                    <div class="filterheader">{{"myorder.dateplacedlabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="MostRecent" (click)="sortTest('MostRecent')"> <span class="radio-button__control"></span>{{"myorder.mostreclabel" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="LeastRecent" (click)="sortTest('LeastRecent')"> <span class="radio-button__control"></span>{{"myorder.leastreclabel" | cxTranslate}}</label>
    
    
                </div>
            </div>
        </div>
        
    </div>
    
    <div class="clearfix"></div>
    
    <hr>
    
    <div *ngIf="isLoading" class="loading">
        <div class="loading_txt">
        <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
     <div *ngIf="!isLoading">
   
    <div class="mat-elevation-z8 " id="orderfiltertable">
        <mat-form-field class="mattablesearch">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="inputsearch($event);applyFilter()" placeholder="Search, filter, or sort your orders">
        </mat-form-field>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
    
     <ng-container matColumnDef="combined" >
 <th class="odertableheader" mat-header-cell *matHeaderCellDef> order Data </th>
      <td mat-cell *matCellDef="let element" (click)="openrightsectio(element.ordernum)"> 
        <div class="tablecolum_order1">
         {{element.season}}
        <div class="order_id">{{element.ordernum}}</div>
        <div class="order_unit"><span>{{"myorder.unitqtylabel" | cxTranslate}}</span><span class="totalorderquantity_Order" [className]=element.ordernum>{{element.unit}}</span></div>
        <div class="order_location"><span>{{"myorder.shiploclabel" | cxTranslate}}</span><span [innerHtml]="element.loc"></span></div>
        </div>
         <div class="tablecolumn_order2">{{element.status}}</div>
        </td>
          
 
      </ng-container>
      
          <!-- Header and Row Declarations -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row id="{{row.ordernum}}" *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row " *matNoDataRow>
            <td class="mat-cell orders no-matching">{{"myorder.nodatamsg" | cxTranslate}}</td>
          </tr>
        </table>
<!--        <mat-paginator #paginator  [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
 -->    
   <div class="custom-paginator">
    <button class="pagination-buttonOrg paddingarrow" (click)="goToFirstPage();scrollToTop()" [disabled]="isFirstPage()" >
      <img alt="Navigate to previous page" src="assets/images/pagination-double-prev-arrow-icon.svg" class="locations_arrows">
    </button>
    <button class="pagination-buttonOrg paddindsinglearrow" (click)="previousPage();scrollToTop()" [disabled]="isFirstPage()">
      <img alt="Navigate to previous page" src="assets/images/pagination-prev-btn.svg" class="locations_arrows">
    </button>
    <button class="pagination-buttonOrg " *ngFor="let pge of getPages()" [class.active-page]="isCurrentPage(pge)" (click)="goToPage(pge);scrollToTop()">
      {{pge}}
    </button>
    <button class="pagination-buttonOrg paddindsinglearrow" (click)="nextPage();scrollToTop()" [disabled]="isLastPage()">
      <img alt="Navigate to next page" src="assets/images/pagination-next-btn.svg" class="locations_arrows">
    </button>
    <button class="pagination-buttonOrg paddingarrow" (click)="goToLastPage();scrollToTop()" [disabled]="isLastPage()">
      <img alt="Navigate to last page" src="assets/images/pagination-double-next-arrow-icon.svg" class="locations_arrows">
    </button>
    </div>  
 </div>
    </div>
    </div>


    <!-- right section for my orders -->
    
    <div *ngIf="rightisLoading" class="loading">
        <div class="loading_txt">
        <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    <div class="mobileright"  id="rightsection">
    <div *ngIf="!rightisLoading">
    <div class="col-lg-7 col-span-12 right-order  order-details-view float_left ">
      
      <ng-container *ngIf="rightsectionresponse">
        <div class="order_details_section col-md-12" id="{{rightsectionresponse.orderID}}">
    
            <div class="order_status_table">
                <div class="row order_panel_header right-first-row">
                    <div class="col-md-5 col-7">
                        <div class="order_id">
                            {{"editorder.orderno" | cxTranslate}}<span class="order_id_fetch">{{rightsectionresponse.orderID}}</span>
                        </div>
                        
                    </div>
                    <div class="col-md-7 col-5 button_wrap" *ngIf="(rightsectionresponse.status === 'Ordered' 
             || rightsectionresponse.totalShippedQty < rightsectionresponse.totalOrderedQty)
             && rightsectionresponse.status !== 'Canceled'">
                           <div
                           class="order_button edit_ord"
                           (click)="viewEditTable()"
                           [ngClass]="{
                             'active': editdata,
                             'edit-disabled': isEditDisabled()
                           }"
                           [attr.aria-disabled]="isEditDisabled()"
                         >
                           Edit Order&nbsp;
                           <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                         </div>
                            
                     </div>
                     <div class="col-md-12" *ngIf="showMessage" 
                        [ngClass]="{
                          'success-message-': messageType === 'success',
                          'error-message-': messageType === 'error'
                        }"
                      >
                        <i
                          [class]="messageType === 'success'
                            ? 'fa-regular fa-circle-check'
                            : 'fa-regular fa-circle-xmark'"
                        ></i>
                      
                        &nbsp;{{ messageText }}
                      </div>
                     <div class="col-md-12 shipping_disabled_txt" *ngIf="showShippingCutoffMessage"><i class="fa-solid fa-alarm-clock"></i>&nbsp;Preparing for shipping, your order cannot be edited at this time.</div>
                </div>
                    <!-- edit order section start's here -->
                    <div *ngIf="iseditLoading" class="loading">
                        <div class="loading_txt">
                            <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                    </div>
                    <div *ngIf="!iseditLoading">
                    <!-- <div *ngIf="editdata" class="editOrderArea">
                        products table
                        <table class="editheader1">
                            <th class="product_Label_Header">{{"editorder.productslabel" | cxTranslate}}</th>
                            <th class="price_Label_Header">{{"editorder.pricelabel" | cxTranslate}}</th>
                            <th class="qty_Label_Header">{{"editorder.qtylabel" | cxTranslate}}</th>
                        </table>
                        <div class="edittablecontainer">
                            <table mat-table [dataSource]="editdatasource" multiTemplateDataRows class="edit-table mat-elevation-z8" >
                                Product Name Column
                                <ng-container matColumnDef="fullProductName">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.baseName | uppercase}}&nbsp;<small>{{element.presentationName}}</small>
                                        <div class="edit_mob_hidden1"> <span>{{element.formattedValue}}</span>per
                                                                                            units inside brackets
                                            unit&nbsp;<small class="edit_mob_inlineshow">[{{element.doses}} doses/unit]</small></div>
                                        To show No stock
                                        <div *ngIf="!element.sellable" class="nostockbanner">{{"editorder.soldouttxt" | cxTranslate}}</div>
                                    </td>
                                </ng-container>
                                Price Column
                                <ng-container matColumnDef="price">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">{{element.formattedValue}}&nbsp;per unit</td>
                                </ng-container>
                                Quantity Column
                                <ng-container matColumnDef="totalOrderdQty">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="editdosecount">
                                            <div>
                                                <input id="prodQtyBox" type="text" [disabled]="!element.sellable" placeholder="0"
                                                    [(ngModel)]="element.quantity" maxlength="4" (keypress)="onKeyPress($event)"
                                                    [ngStyle]="{'border':element.errorMessage ? '1px solid red':'1px solid grey'}">
                                            </div>
                                            <div>{{"editorder.unitslabel" | cxTranslate}}&nbsp;&nbsp;<br><span          
                                                    class="mobile_view_hide"><small>[{{element.doses}} doses/unit]</small></span>                                
                                            </div>
                                        </div>
                                </ng-container>
                                <ng-container matColumnDef="errorMessage">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" colspan="3">
                                        <div *ngIf="element.errorMessage" class="error-message">{{element.errorMessage}}</div>
                                    </td>
                                </ng-container>
                    
                    
                                <tr class="editheader" mat-header-row *matHeaderRowDef="editcolumns"></tr>
                                <tr mat-row *matRowDef="let element; columns: ['fullProductName','price','totalOrderdQty']"></tr>
                                <tr mat-row class="errorrow" *matRowDef="let element; columns:['errorMessage']" [class.hidden]="!element.errorMessage"></tr>
                            </table>
                        </div>
                        Footer area
                        <div class="editproductfooter">
                            <div>{{"editorder.totallabel" | cxTranslate}} &nbsp;
                                for mobile view price beside total
                                <span class="edit_mob_inlineshow totalprice total_order_price5">${{calculateTotalPrice()}}</span>
                            </div>
                            for desktop site price
                            <div class="edit_mob_hidden"><span class="totalprice total_order_price1">${{calculateTotalPrice()}}</span>
                            </div>
                    
                            <div><span class="total_ord_qty total_ord_qty_edit total_order1"></span>{{calculateTotalQuantiy()}} {{"editorder.unitslabel" | cxTranslate}}
                               <span class="total_ord_doses total_order1">{{calculateTotalDoses() | number:'1.0-0'}} Doses</span>
                            </div>
                            
                        </div>
                        cancel order section
                         <div *ngIf="isPreSeason && rightsectionresponse.status=='Ordered'" class="cancel_editorder">
                            <div class="col-5 col-md-3 cancel_link" data-bs-toggle="modal" data-bs-target="#cancelorder_popup">{{"editorder.cancelOrdertxt" | cxTranslate}}</div>
                         </div>
                    cancel order section ends
                        <div class="membershiparea">
                            membership details
                            <div class="row order_panel_header editscreenbootomdetails">
                                <div class="membershipdetails col-xs-12">
                                    <div *ngIf="membershipdata.isMembershipDeclared">
                                        <div *ngIf="activemembership">
                                            <p>{{activemembership.title}} {{membershipdata.currentMembership}}</p>
                                            <div class="underline-links" [innerHTML]="activemembership.content"></div>
                                        </div>
                                       
                                    </div>
                                    <div *ngIf="!membershipdata.isMembershipDeclared">
                                        <div *ngIf="nomembership">
                                            <p>{{nomembership.title}} {{membershipdata.currentMembership}}</p>
                                              <div class="underline-links" [innerHTML]="nomembership.content"></div>
                                        </div>   
                                    </div>
                                </div>
                                Edit section membership changes end's
                                <div class="col-md-3">
                                    <div class="order_level">{{"editorder.polabel" | cxTranslate}}</div>
                                    <div class="">
                                        <input type="text" class="form-control order_edit_fld edit_PO_Txt"  [(ngModel)]="rightsectionresponse.poNumber" maxlength="12" (keypress)="onKeyPressPO($event)">
                                    </div>
                                </div>
                    
                                <div class="col-md-5 mob-padding-edit">
                                    <div class="order_level">{{"editorder.shiploclabel" | cxTranslate}}</div>
                                    <div class="edit_Shipping_Txt">{{rightsectionresponse.addressLine1}} {{rightsectionresponse.addressLine2}},{{rightsectionresponse.city}},{{rightsectionresponse.state}},{{rightsectionresponse.zipCode}}</div>
                                </div>
                                <div class="col-md-4">
                                    <div class="order_level">{{"editorder.billloclabel" | cxTranslate}}</div>
                                    <div class="edit_Billing_Txt">{{rightsectionresponse.billAddressLine1}} {{rightsectionresponse.billAddressLine2}}</div>
                                </div>
                                <div *ngIf="poError" class="po_Error_Message col-xs-12" >{{ "editorder.poErrorMsg" | cxTranslate }}</div>
                                <div class="membershipdetails col-xs-12">
                                    <div class="padding-T10" [innerHTML]="'editorder.contactmsg' | cxTranslate"></div>
                                </div>
                            </div>

                            <div class="row order_panel_header no-border-B">
                                <div class="col-md-6">
                                    <a class="cancel_btn_edit" (click)="closeEditOrderArea()" id="1">{{"editorder.closelabel" | cxTranslate}}</a>
                                </div>
                                <div class="col-md-6">
                                    <input type="submit" class="save_btn_edit updateOrderClick" value="Save" (click)="saveOrder()"
                                        [disabled]="!isFormValid || poError">
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- shipping flexibility edit order start -->
                    <div *ngIf="editdata" class="editOrderArea">
                        <!--products table -->
                        <table class="editheader1">
                            <th class="product_Label_Header">{{"editorder.productslabel" | cxTranslate}}</th>
                            <th class="price_Label_Header">{{"editorder.pricelabel" | cxTranslate}}</th>
                            <th class="qty_Label_Header">{{"editorder.qtylabel" | cxTranslate}}</th>
                        </table>
                        <div class="edittablecontainer">
                            <table mat-table [dataSource]="editdatasource" multiTemplateDataRows class="edit-table mat-elevation-z8" >
                                <!-- Product Name Column -->
                                <ng-container matColumnDef="fullProductName">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.baseName | uppercase}}&nbsp;<small>{{element.presentationName}}</small>
                                        <div class="edit_mob_hidden1"> <span>{{element.formattedValue}}</span>per
                                                                                            <!--units inside brackets-->
                                            unit&nbsp;<small class="edit_mob_inlineshow">[{{element.doses}} doses/unit]</small></div>
                                        <!--To show No stock-->
                                        <div *ngIf="!element.sellable" class="nostockbanner">{{"editorder.soldouttxt" | cxTranslate}}</div>
                                    </td>
                                </ng-container>
                                <!-- Price Column -->
                                <ng-container matColumnDef="price">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">{{element.formattedValue}}&nbsp;per unit</td>
                                </ng-container>
                                <!-- Quantity Column -->
                                <ng-container matColumnDef="totalOrderdQty">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="editdosecount">
                                            <div>
                                                <input id="prodQtyBox" type="text" [disabled]="!element.sellable" placeholder="0"
                                                    [(ngModel)]="element.quantity" maxlength="4" (keypress)="onKeyPress($event)"
                                                    [ngStyle]="{'border':element.errorMessage ? '1px solid red':'1px solid grey'}">
                                            </div>
                                            <div>{{"editorder.unitslabel" | cxTranslate}}&nbsp;&nbsp;<br><span          
                                                    class="mobile_view_hide"><small>[{{element.doses}} doses/unit]</small></span>                                
                                            </div>
                                        </div>
                                </ng-container>
                                <ng-container matColumnDef="errorMessage">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" colspan="3">
                                        <div *ngIf="element.errorMessage" class="error-message">{{element.errorMessage}}</div>
                                    </td>
                                </ng-container>
                    
                    
                                <tr class="editheader" mat-header-row *matHeaderRowDef="editcolumns"></tr>
                                <tr mat-row *matRowDef="let element; columns: ['fullProductName','price','totalOrderdQty']"></tr>
                                <tr mat-row class="errorrow" *matRowDef="let element; columns:['errorMessage']" [class.hidden]="!element.errorMessage"></tr>
                            </table>
                        </div>
                        <!--Footer area-->
                        <div class="editproductfooter">
                            <div>{{"editorder.totallabel" | cxTranslate}} &nbsp;
                                <!--for mobile view price beside total-->
                                <span class="edit_mob_inlineshow totalprice total_order_price5">${{calculateTotalPrice()}}</span>
                                <span class="editfedexcise_txt">before federal excise tax</span>
                            </div>
                            <!--for desktop site price-->
                            <div class="edit_mob_hidden"><span class="totalprice total_order_price1">${{calculateTotalPrice()}}</span>
                            </div>
                    
                            <div><span class="total_ord_qty total_ord_qty_edit total_order1"></span>{{calculateTotalQuantiy()}} {{"editorder.unitslabel" | cxTranslate}}
                               <span class="total_ord_doses total_order1">{{calculateTotalDoses() | number:'1.0-0'}} Doses</span>
                            </div>
                            
                        </div>
                        <!-- cancel order section -->
                         <div *ngIf="isPreSeason && rightsectionresponse.status=='Ordered'" class="cancel_editorder">
                            <div class="col-5 col-md-3 cancel_link" data-bs-toggle="modal" data-bs-target="#cancelorder_popup">{{"editorder.cancelOrdertxt" | cxTranslate}}</div>
                         </div>
                          <!-- delivery details section -->
                            <div *ngIf="isInSeason && rightsectionresponse.status=='Ordered'&& shouldShowDeliveryDetails()" class="delivery_details_outer">
                                <div class="delivery_details_inner">
                                    <span class="estimated_delivery_label">Estimated delivery</span>
                                    <div *ngFor="let item of items; let i = index">
                                    <span class="delivery_date_txt"><input class="date-box"  type="text" [value]=" confirmedDates[i] | date: 'EEEE, MMMM d, y':'America/New_York'" readonly ></span>
                                      <a *ngIf="!requiresCustomerService" class="reschedule_delivery_link" (click)="openCalendar(i, $event)">Reschedule delivery</a>
                                      <a *ngIf="requiresCustomerService" class="reschedule_delivery_link" (click)="showRescheduleModal = true; $event.stopPropagation()">Reschedule delivery</a>
                                      <p class="reschedule_count">
                                        {{ getRemainingRescheduleCount() }} of {{rightsectionresponse.shippingCalendar.maxrRescheduleCount}} delivery date changes remaining
                                        <span *ngIf="getRemainingRescheduleCount() === 0">
                                            (Reschedule limit reached)
                                          </span>
                                      </p>
                                    <div
                                    class="calendar-backdrop-mobile"
                                    *ngIf="openCalendarIndex === i"
                                    (click)="closeCalendar()"
                                    ></div>
                                    <div
                                    class="calendar-wrapper"
                                    *ngIf="openCalendarIndex === i"
                                    (click)="$event.stopPropagation()"
                                    >
                                    <div class="calendar-mobile-header">
                                        <span class="calendar-mobile-title">Reschedule delivery</span>
                                        <span class="calendar-mobile-close" (click)="closeCalendar()">
                                        <img src="../../../assets/images/cancel_btn.png" 
                                            alt="Close" 
                                            width="24" 
                                            height="24">
                                        </span>
                                    </div>
                                     <img src="../../../assets/images/Triangle_icon.svg" alt="" class="calendar-triangle">
                                    <div class="custom-month-label">
                                        {{ monthLabel }}
                                    </div>

                                    <mat-calendar
                                        #calendar
                                        [minDate]="minSelectableDate"
                                        [maxDate]="maxSelectableDate"
                                        [dateFilter]="dateFilter"
                                        [selected]="tempSelectedDates[0]" 
                                        [startAt]="tempSelectedDates[0]"
                                        (selectedChange)="onDateSelected(i, $event)"
                                    >
                                    </mat-calendar>

                                    <div class="calendar-info">
                                        <mat-icon>info_outline</mat-icon>
                                        {{ deliveryConfig.infoText }}
                                    </div>

                                    <button
                                        mat-stroked-button
                                        color="primary"
                                        [disabled]="!tempSelectedDates[0]"
                                        (click)="confirmDate(0)"
                                    >
                                        Update Delivery
                                    </button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                          <!-- delivery details section ends-->
                    <!-- cancel order section ends-->
                        <div class="membershiparea">
                            <!--membership details-->
                            <div class="row order_panel_header editscreenbootomdetails">
                                <div class="membershipdetails col-xs-12">
                                    <div *ngIf="membershipdata.isMembershipDeclared">
                                        <div *ngIf="activemembership">
                                            <p>{{activemembership.title}} <span class="membership_type">{{membershipdata.currentMembership}}</span></p>
                                            <div class="underline-links" [innerHTML]="activemembership.content"></div>
                                             <div class="edit_membership_msg">You can edit your current membership in <a class="edit_membership_profile_link" href="/my-profile">My Profile</a>.</div>
                                        </div>
                                        
                                       
                                    </div>
                                    <div *ngIf="!membershipdata.isMembershipDeclared">
                                        <div *ngIf="nomembership">
                                             <p>{{nomembership.title}} <span class="membership_type">{{membershipdata.currentMembership}}</span></p>
                                              <div class="underline-links" [innerHTML]="nomembership.content"></div>
                                              <div class="edit_membership_msg">You can edit your current membership in <a class="edit_membership_profile_link" href="/my-profile">My Profile</a>.</div>
                                        </div>   
                                    </div>
                                </div>
                                <!--Edit section membership changes end's -->
                                <div class="col-md-3">
                                    <div class="order_level">{{"editorder.polabel" | cxTranslate}}</div>
                                    <div class="">
                                        <input type="text" class="form-control order_edit_fld edit_PO_Txt"  [(ngModel)]="rightsectionresponse.poNumber" maxlength="12" (keypress)="onKeyPressPO($event)">
                                    </div>
                                </div>
                    
                                <div class="col-md-5 mob-padding-edit">
                                    <div class="order_level">{{"editorder.shiploclabel" | cxTranslate}}</div>
                                    <div class="edit_Shipping_Txt">{{rightsectionresponse.addressLine1}} {{rightsectionresponse.addressLine2}},{{rightsectionresponse.city}},{{rightsectionresponse.state}},{{rightsectionresponse.zipCode}}</div>
                                </div>
                                <div class="col-md-4">
                                    <div class="order_level">{{"editorder.billloclabel" | cxTranslate}}</div>
                                    <div class="edit_Billing_Txt">{{rightsectionresponse.billAddressLine1}} {{rightsectionresponse.billAddressLine2}}</div>
                                </div>
                                <div *ngIf="poError" class="po_Error_Message col-xs-12" >{{ "editorder.poErrorMsg" | cxTranslate }}</div>
                                <div class="membershipdetails col-xs-12">
                                    <div class="padding-T10" [innerHTML]="'editorder.contactmsg' | cxTranslate"></div>
                                </div>
                            </div>

                            <div class="row order_panel_header no-border-B">
                                <div class="col-md-6">
                                    <a class="cancel_btn_edit" (click)="closeEditOrderArea()" id="1">{{"editorder.closelabel" | cxTranslate}}</a>
                                </div>
                                <div class="col-md-6">
                                    <input type="submit" class="save_btn_edit updateOrderClick" value="Save" (click)="saveOrder()"
                                        [disabled]="!isFormValid || poError">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- shipping flexibility edit order end -->
                    </div>
                    <!-- edit order section end's here -->
              
                <div class="row order_panel_header" *ngIf="!editdata">
                    <div class="col-md-2 col-4">
                        <div class="order_status_header">{{"editorder.placedon" | cxTranslate}}</div>
                        <div class="order_substaus">
                            {{rightsectionresponse.orderDate}}</div>
                    </div>
                    <div class="col-md-3 col-4">
                        <div class="order_status_header">{{"editorder.placedby" | cxTranslate}}</div>
                    <div class="order_substaus">{{rightsectionresponse.placedBy}}</div>
                    </div>
                    <div class="col-md-2 col-4 mobpadding">
                        <div class="order_status_header">{{"editorder.poNum" | cxTranslate}}</div>
                        <div class="order_substaus">{{rightsectionresponse.poNumber}}</div>
                    </div>
                    <div class="col-md-5 col-12 mobile_MT">
                        <div class="order_status_header">{{"editorder.shiploclabel" | cxTranslate}}</div>
                        <div class="order_substaus">
                            {{rightsectionresponse.addressLine1}} {{rightsectionresponse.addressLine2}},
                            {{rightsectionresponse.city}}, {{rightsectionresponse.state}}
                            &nbsp;{{rightsectionresponse.zipCode}}</div>
                    </div>
                </div>
    
                <div class="row order_panel_header no-border-B" *ngIf="!editdata">
                    <div class="col-xs-12 col-md-6"> <!-- mobile view change-->
                        <div class="order_status_header quantity_header">{{"editorder.orderqtydelivered" | cxTranslate}}</div>
                        <div class="order_substaus margin-T10 margin-B30">
                            <strong class="crnt-ord"><span class="crnt_order_qty">{{rightsectionresponse.totalShippedQty}}</span>
                                {{"editorder.unitslabel" | cxTranslate}}</strong> / <span class="total_qty total_qty0">{{rightsectionresponse.totalOrderedQty}}</span>
                        </div>
                        <div class="progress progressUS margin-B20">
                            <mat-progress-bar mode="determinate" value= {{getProgress(rightsectionresponse.totalShippedQty,rightsectionresponse.totalOrderedQty)}}></mat-progress-bar>
                        </div>
                        <div class="col-md-3 col-4 order-status-new-parent">
                            <div class="current_order_status order-status-new">
                            <strong>{{"editorder.status" | cxTranslate}}</strong>&nbsp;<span class="ordstat">{{rightsectionresponse.status}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6"> <!-- mobile view change-->
                        <div class="order_status_header payment_header">{{"editorder.payprogress" | cxTranslate}}</div>
                        <div class="order_substaus margin-T10 margin-B30">
                            <strong class="crnt-ord">$
                            <span class="crnt_payment_qty" *ngIf="rightsectionresponse.status=='Ordered' || rightsectionresponse.status=='Shipped' || rightsectionresponse.status=='Canceled'">0.00</span>
</strong>
                                <strong><span class="crnt_payment_qty"  *ngIf="rightsectionresponse.status=='Delivered'"> {{rightsectionresponse.totalCost | number:'1.2-2'}}</span></strong> 
                               <span class="total_payment_text"> / $</span>
                                    <span class="total_pymnt">
                                        {{rightsectionresponse.totalCost | number:'1.2-2'}}</span>
                                    <span class="total_payment_text">&nbsp;total</span>
                        </div>
                        <div class="progress progressUS margin-B20"> <!-- mobile view change-->


                            <ng-container *ngIf="rightsectionresponse.status=='Ordered' || rightsectionresponse.status=='Shipped' || rightsectionresponse.status=='Canceled'">
                            <mat-progress-bar mode="determinate" value= getProgress(0,rightsectionresponse.totalCost)></mat-progress-bar></ng-container>
                            <ng-container *ngIf="rightsectionresponse.status=='Delivered'">
                                <mat-progress-bar mode="determinate" value= {{getProgress(rightsectionresponse.totalCost,rightsectionresponse.totalCost)}}></mat-progress-bar></ng-container>
                       </div>
                        <div class="row">
                            <div class="col-md-7 col-7">
                                <div class="order_status_header invoice-header">
                                    <strong>{{"editorder.status" | cxTranslate}}</strong>&nbsp;<span *ngIf="rightsectionresponse.invoiceAvailable=='true';else noinvoice">{{"editorder.invavailable" | cxTranslate}}</span><ng-template #noinvoice>{{"editorder.noinvavailable" | cxTranslate}}</ng-template></div>
                            </div>
                            <div class="col-md-5 col-5"  *ngIf="rightsectionresponse.invoiceAvailable=='true'">
                                <a [routerLink]="'/financial-dashboard/all-invoices'" [queryParams]="{ season :invoiceseason ,invoice:invoicenumber }" class="order_status_header invoicelink "><strong><span class="h_viewinvoice">{{"editorder.viewinvtxt" | cxTranslate}}</span>&nbsp; →</strong></a>
                                </div>
                            <div class="col-md-5 col-5">
                                </div>
                        </div>
                    </div>
                </div>
                    
                <!--orders shipping changes starts-->
                 <div class="row order_panel_header order_shipping_details" *ngIf="!editdata">
                    <div class="col-md-12 order_id ">{{"editorder.shipdetail" | cxTranslate}}</div>

                 <div *ngIf="rightsectionresponse.status=='Ordered' && rightsectionresponse.ispromisedDateAvailable=='false'" class="col-md-12 margin-T20 no_order_shipping">{{"editorder.checksoontxt" | cxTranslate}}</div>
                 <div *ngIf="rightsectionresponse.status=='Canceled'" class="col-md-12 margin-T20 no_order_shipping">{{"editorder.cancelmsg" | cxTranslate}}</div>
                 <div *ngIf="(rightsectionresponse.status=='Ordered' && rightsectionresponse.ispromisedDateAvailable=='true') || rightsectionresponse.status=='Shipped' || rightsectionresponse.status=='Delivered'" class="col-md-12">
                    <div class="col-md-12 margin-T20 order_accordian padding-T10 panel-group" id="order_accordian_{{rightsectionresponse.orderID}}">
<!-- loop start -->

<div *ngFor="let list of rightsectionresponse?.shippingVisibilityTable?.shippingDetails;let i=index" class="panel panel-default">
    <div class="panel-heading no-padding">
        <h4 class="panel-title">
            <a data-bs-toggle="collapse" class="accordion-toggle collapsed" [ngClass]="list.status=='Delivered'?'delivered':''" href="#accordian_header{{i}}" aria-expanded="false">{{list.statusWithDate}}</a>
        </h4>
    </div>
    <div id="accordian_header{{i}}" class="panel-collapse collapse orders_Tracking_Accordion" aria-expanded="false">

        <div class="panel-body no-padding">
            <div class="orders_view_tracking " *ngIf="list?.tracking?.link"><a target="_blank" href="{{list?.tracking?.link}}" class="orders_view_tracking_link">{{"editorder.viewtracking" | cxTranslate}}<i class="global_blackarrow"></i></a></div>
            <table class="orders_Tracking_Table">
                <thead>
                    <tr>
                        <th>{{"editorder.productlabel" | cxTranslate}}</th>
                        <th>{{"editorder.quantity" | cxTranslate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let items of list?.productDetail">
                        <td>{{items.productName}}</td>
                        <td>{{items.itemQty}} {{"editorder.unitslabel" | cxTranslate}}</td>

                    </tr>
                   <tr>
                    <td >{{"editorder.totallabel" | cxTranslate}} </td>
                    <td>{{ getTotal(list?.productDetail)}} {{"editorder.unitslabel" | cxTranslate}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>
                   
<!-- loop ends -->
                    </div>
                 </div>

                 <!-- <div class="col-md-12 margin-T20 order_accordian panel-group" id="{{'order_accordian_' + rightsectionresponse.orderID}}">
                    <div class="panel panel-default product_details_table">
                        <div class="panel-heading">
                            <h4 class="panel-title order_shipped_status">
                                <a data-toggle="collapse" class="accordion-toggle" href="#accordian_header1" aria-expanded="true">Shipped on  May 31</a>
                            </h4>
                        </div>
                        <div id="accordian_header1" class="panel-collapse collapse in" aria-expanded="true" style="">
                            <div class="panel-body">
                                <table class="shipping_table">
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>AFLURIA</td>
                                            <td>1 units</td>
                                        </tr>
                                        <tr>
                                            <td>FLUCELVAX</td>
                                            <td>1 units</td>
                                        </tr>
                                        <tr>
                                            <td>FLUAD</td>
                                            <td>1 units</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>3 units</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div> -->
                    </div>
                <!--orders shipping changes Ends-->
    
    <div class="shipping_title">{{"editorder.productdetail" | cxTranslate}}</div>
 
      <!-- <div class="ordertivtext" *ngIf="rightsectionresponse.preSeason==dropdownValue"><div>2024-2025 season will ship as trivalent formulations. No action is needed from you.</div>
	<a class="ordertivtextanchor" href="/digital_customer_letter_tiv_vaccines_24-25" target="blank">Read our full Customer Letter</a>
	<i class="tiv_redarrow" style="background-image: url('../assets/images/red_arrow.png');"></i>
</div>  -->
 <table mat-table 
       [dataSource]="dataSource1" multiTemplateDataRows class="productdetailTable mat-elevation-z8 d-none d-md-block d-lg-block">
       <ng-container matColumnDef="fullProductName">
        <th mat-header-cell *matHeaderCellDef>{{"editorder.productlabel" | cxTranslate}}</th>
        <td mat-cell *matCellDef="let row">{{row.fullProductName}}</td>
    </ng-container>
    <ng-container matColumnDef="totalOrderdQty">
        <th mat-header-cell *matHeaderCellDef>{{"editorder.qtylabel" | cxTranslate}}</th>
        <td mat-cell *matCellDef="let row">{{row.totalOrderdQty}} {{"editorder.unitslabel" | cxTranslate}}</td>
    </ng-container>
    <ng-container matColumnDef="totalInvoiceAmount">
        <th mat-header-cell *matHeaderCellDef>{{"editorder.invoicedlabel" | cxTranslate}}</th>
        <td mat-cell *matCellDef="let row">${{row.totalInvoiceAmount | number:'1.2-2'}}</td>
    </ng-container>
    <ng-container matColumnDef="totalShippedQty">
        <th mat-header-cell *matHeaderCellDef>{{"editorder.deliveredlabel" | cxTranslate}}</th>
        <td mat-cell *matCellDef="let row">{{row.totalShippedQty}}/{{row.totalOrderdQty}}</td>
    </ng-container>
    <ng-container matColumnDef="latestStatus">
        <th mat-header-cell *matHeaderCellDef>{{"editorder.nextdelivery" | cxTranslate}}</th>
        <td mat-cell *matCellDef="let row" class="details-control">
             <ng-container *ngIf="row.latestStatus.toUpperCase()=='Check back soon'.toUpperCase();else expandrow">
                 <div [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'">{{row.latestStatus}} <i class="fa fa-caret-down view_status inactive" aria-hidden="true"></i></div> 
            </ng-container>
            <ng-template #expandrow>
                <ng-container *ngIf="row.latestStatus.toUpperCase()=='All deliveries completed'.toUpperCase();else expandrow1">
                <div [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'"  [ngClass]="row.latestStatus=='All deliveries completed'?'delivered':''" (click)="toggleRow(row)"> {{row.latestStatus}}<i class="fa fa-caret-down view_status active" aria-hidden="true"></i></div> 
                </ng-container>
            </ng-template> 
     <ng-template #expandrow1>
            <div  [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'"  [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'" (click)="toggleRow(row)">{{row.latestStatus}} <i class="fa fa-caret-down view_status active" aria-hidden="true"></i></div> 
            </ng-template>
         </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr> 
    <tr class="mat-row " *matNoDataRow>
        <td class="nodata" colspan="5">{{"myorder.nodatamsg" | cxTranslate}}</td>
      </tr>          
     <ng-container>
      <tr  mat-row *matRowDef="let row; columns:displayedColumns1;let i=index" [class.expanded-row]="row.expanded" ></tr>
    </ng-container> 
    
        <tr class="tabledetailrow" *matRowDef="let row; columns: [];  let i=index" [class.expanded-row]="row.expanded"> 
            <ng-container>

            <td [attr.colspan]="5">

                <table class="subtable">
                    <thead>
                        <tr>
                            <th>{{"editorder.qtylabel" | cxTranslate}}</th>
                            <th>{{"editorder.statuslabel" | cxTranslate}}</th>
                            <th>{{"editorder.trackinglabel" | cxTranslate}}</th>
                           
                        </tr>
                    </thead>
                    <!-- <ng-container > -->
                    <tr *ngFor="let data of row.shippedStatusTable" >
                        <td>{{data.quantity}} {{"editorder.unitslabel" | cxTranslate}}</td>
                        <td class="product_Shipped" [ngClass]="data.shipmentStatus?.includes('Delivered')?'delivered':'redcolortext'">{{data.shipmentStatus}}</td>
                        <td><a class="productDetails_viewTracking"  *ngIf="data?.trackingLink" target="_blank" href="{{data?.trackingLink}}">{{"editorder.viewtracking" | cxTranslate}} <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a></td>

                    </tr>
                <!-- </ng-container> -->
                </table>
            </td>
        </ng-container>
    </tr> 
  
    
      
  
</table>

<!-- mobile view -->
<table mat-table
[dataSource]="dataSource1" multiTemplateDataRows class="productdetailTable mobiletable mat-elevation-z8 d-block d-md-none d-lg-none">
<ng-container matColumnDef="combined" >
    <th class="odertableheader d-none" mat-header-cell *matHeaderCellDef> order Data </th>
    <td mat-cell *matCellDef="let row"> 
        <div class="tabledivorders">
        <div class="mobile_prod_table">
            <div class="table_product">{{row.fullProductName}}</div>
            <div class="table_icon">
                <ng-container *ngIf="row.latestStatus.toUpperCase()=='Check back soon'.toUpperCase();else expandrow">
                    <div [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'"> <i class="fa fa-caret-down view_status inactive" aria-hidden="true"></i></div> 
               </ng-container>

               
               <ng-template #expandrow>
                <div  [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'"  [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'" (click)="toggleRow(row)"> <i class="fa fa-caret-down view_status active xxx" aria-hidden="true"></i></div> 
                </ng-template>
                
            </div>
        </div>
        <div class="mobile_prod_table">
            <div class="table_header">{{"editorder.quantity" | cxTranslate}}:</div>
            <div class="table_value">{{row.totalOrderdQty}} {{"editorder.unitslabel" | cxTranslate}}</div>
        </div>
        <div class="mobile_prod_table">
            <div class="table_header">{{"editorder.invoicedlabel" | cxTranslate}}:</div>
            <div class="table_value">${{row.totalInvoiceAmount | number:'1.2-2'}}</div>
        </div>
        <div class="mobile_prod_table">
            <div class="table_header">{{"editorder.deliveredlabel" | cxTranslate}}:</div>
            <div class="table_value">{{row.totalShippedQty}}/{{row.totalOrderdQty}} </div>
        </div>
        <div class="mobile_prod_table">
            <div class="table_header">{{"editorder.nextdelivery" | cxTranslate}}:</div>
            <div class="table_value"> 
                <div [ngClass]="row.latestStatus=='Check back soon'?'checkback':row.latestStatus=='All deliveries completed'?'checkback':'redcolortext'">{{row.latestStatus}}</div> 
              <!--   <ng-container *ngIf="row.latestStatus.toUpperCase()=='Check back soon'.toUpperCase();else expandrow1">
                    <div [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'">{{row.latestStatus}}</div> 
                </ng-container>
               <ng-template #expandrow1>
                    <ng-container *ngIf="row.latestStatus.toUpperCase()=='All deliveries completed'.toUpperCase();else expandrow">
                        <div [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'"  [ngClass]="row.latestStatus=='All deliveries completed'?'checkback':''" (click)="toggleRow(row)">{{row.latestStatus}}</div> 
                    </ng-container>
                </ng-template>
                    <ng-template #expandrow>
                         <div [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'"  [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'" (click)="toggleRow(row)">{{row.latestStatus}}</div> 
                     </ng-template> -->
            </div>
        </div>
       </div>

    </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> 
        
<ng-container>
<tr  mat-row *matRowDef="let row; columns:displayedColumns;let i=index" [class.expanded-row]="row.expanded" ></tr>
</ng-container> 

 <tr class="tabledetailrow" *matRowDef="let row; columns: [];  let i=index" [class.expanded-row]="row.expanded"> 
     <ng-container>

     <td [attr.colspan]="5">

         <table class="subtable">
             <thead>
                 <tr>
                     <th>{{"editorder.qtylabel" | cxTranslate}}</th>
                     <th>{{"editorder.statuslabel" | cxTranslate}}</th>
                     <th>{{"editorder.trackinglabel" | cxTranslate}}</th>
                    
                 </tr>
             </thead>
             <!-- <ng-container > -->
             <tr *ngFor="let data of row.shippedStatusTable" >
                 <td>{{data.quantity}} {{"editorder.unitslabel" | cxTranslate}}</td>
                 <td class="product_Shipped" [ngClass]="row.latestStatus=='Check back soon'?'checkback':'redcolortext'">{{data.shipmentStatus}}</td>
                 <td><a class="productDetails_viewTracking"  *ngIf="data?.trackingLink" target="_blank" href="{{data?.trackingLink}}">{{"editorder.viewtracking" | cxTranslate}}<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a></td>
             </tr>
         <!-- </ng-container> -->
         </table>
     </td>
 </ng-container>
</tr> 




</table>
            </div>
        </div>
    </ng-container>
    </div>
</div>
</div>
<div id="cancelorder_popup" class="modal" role="dialog" tabindex="-1"
    aria-labelledby="cancelordermodal" aria-hidden="true">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-body">
                <div class="cancel_close pull-right col-xs-12 col-lg-12"><span class="cancelorder_close" data-bs-dismiss="modal" aria-label="Close">×</span></div>
                <h4 class="modal-title cancelorder_header col-xs-12 col-lg-12">{{"cancelOrder.title" | cxTranslate}}</h4>
                <p class="cancelorder_subheader col-xs-12">
                    {{"cancelOrder.subheader" | cxTranslate}}
                </p>
                <div class="clearboth"></div>
                <div class="cancelorder_buttons">
                    <button type="button" class="cancelorder_No global_redbtn" data-bs-dismiss="modal"
                        #closeButton>{{"cancelOrder.noLabel" | cxTranslate}}</button>
                    <button class="cancelorder_Yes global_greybtn" data-bs-dismiss="modal" (click)="cancelOrder()">{{"cancelOrder.yesLabel" | cxTranslate}}</button>
                    
                </div>
            </div>
        </div>
    </div>
</div>  



  <div class="reschedule_modal_overlay" *ngIf="showRescheduleModal">
      <div class="reschedule_modal">
          <div class="reschedule_modal_content">
              <div class="reschedule_modal_title_row">
                  <span class="reschedule_modal_title">Additional changes require Customer Service.</span>
                   <span class="reschedule_modal_x" (click)="showRescheduleModal = false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 18L18 6" stroke="#2A3237" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 6L18 18" stroke="#2A3237" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
              </div>
              <div class="reschedule_modal_desc">
                  To make changes to your delivery date, please contact Customer Service at
                   <a class="reschedule_phone_link" href="mailto:customerservice.us@seqirus.com" target="_blank">customerservice.us@seqirus.com</a>
              </div>
          </div>
        <button class="reschedule_close_btn" (click)="showRescheduleModal = false">Close</button>
      </div>
  </div>